import { jsx as _jsx } from "react/jsx-runtime";
import './WaitingAlert.scss';
import { SvgSpinner } from '../../icons/spinner';
import { useLoadingIndicatorDelay } from '../../hooks';
import { Alert, SIZE } from './Alert';
export { SIZE };
export const WaitingAlert = (props) => {
    const show = useLoadingIndicatorDelay();
    return show ? (_jsx("div", { className: 'sg-waitingAlert', children: _jsx(Alert, { type: 'info', icon: _jsx(SvgSpinner, {}), ...props }) })) : null;
};
//# sourceMappingURL=WaitingAlert.js.map